<div class="center">
  <div>
    <div class="waiting">{{'onboarding.messages.finishing_off' | translate}}</div>
  </div>
</div>
